module.exports = __webpack_public_path__ + "static/assets/8e3aa3d43f53d3e3e86cc7c2430ba5ac.svg";